<template>
    <div class="dashboard-body-futuristic">
        <main class="futuristic-container">
            <AppSidebar :activeItem="sidebarActive" />

            <section class="dashboard-card-futuristic dashboard-card-scrollable">
                <div class="file-list-wrapper">
                    <!-- Centered Navigation Header -->
                    <!-- Centered Navigation Header - Hidden in Form Mode -->
                    <div v-if="!showObligationForm && cameFromAdmin" class="admin-header-premium">
                        <div class="tabs-modern-dock">
                            <button :class="['tab-dock-btn', { active: activeTab === 'stats' }]" @click="activeTab = 'stats'">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>
                                Overview
                            </button>
                            <button :class="['tab-dock-btn', { active: activeTab === 'users' }]" @click="activeTab = 'users'">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                                Team
                            </button>
                            <button :class="['tab-dock-btn', { active: activeTab === 'pdfs' }]" @click="activeTab = 'pdfs'">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                Contract Docs
                            </button>
                            <button :class="['tab-dock-btn', { active: activeTab === 'licenses' }]" @click="activeTab = 'licenses'">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                Licenses
                            </button>
                            <button v-if="postBidEnabled" :class="['tab-dock-btn', { active: activeTab === 'obligations' }]" @click="activeTab = 'obligations'">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                                Compensation Claims
                            </button>
                            <button v-if="postBidEnabled" :class="['tab-dock-btn', { active: activeTab === 'emails' }]" @click="activeTab = 'emails'">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                                Email Records
                            </button>
                            <button :class="['tab-dock-btn', { active: activeTab === 'reprocess' }]" @click="activeTab = 'reprocess'">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                                Reprocessing
                            </button>
                        </div>
                    </div>

                    <!-- Opened from a bid/project (deep link): the admin tab dock is
                         hidden, so give a clear way back to that bid's Project tab. -->
                    <div v-if="backToBidId && !showObligationForm" class="back-to-bid-bar">
                        <button type="button" class="btn-cancel-floating" @click="goBackToBid()">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                                <line x1="19" y1="12" x2="5" y2="12"></line>
                                <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                            Back to Bid
                        </button>
                    </div>

                    <!-- Bento Grid Overview - Hidden in Form Mode -->
                    <div v-if="activeTab === 'stats' && !showObligationForm" class="admin-content-fade">
                        <div class="premium-stats-grid">
                            <div class="premium-stat-card blue clickable" role="button" tabindex="0" @click="activeTab = 'users'" @keydown.enter="activeTab = 'users'" @keydown.space.prevent="activeTab = 'users'">
                                <div class="card-header-compact">
                                    <div class="card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg></div>
                                    <h2 class="stat-number">{{ stats.total_users }}</h2>
                                </div>
                                <div class="card-info"><h4>Total Users</h4></div>
                                <div class="card-glow"></div>
                            </div>
                            <div class="premium-stat-card purple clickable" role="button" tabindex="0" @click="activeTab = 'pdfs'" @keydown.enter="activeTab = 'pdfs'" @keydown.space.prevent="activeTab = 'pdfs'">
                                <div class="card-header-compact">
                                    <div class="card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></div>
                                    <h2 class="stat-number">{{ stats.total_pdfs }}</h2>
                                </div>
                                <div class="card-info"><h4>Contract Docs</h4></div>
                                <div class="card-glow"></div>
                            </div>
                            <div class="premium-stat-card cyan clickable" role="button" tabindex="0" @click="activeTab = 'licenses'" @keydown.enter="activeTab = 'licenses'" @keydown.space.prevent="activeTab = 'licenses'">
                                <div class="card-header-compact">
                                    <div class="card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>
                                    <h2 class="stat-number">{{ stats.total_licenses }}</h2>
                                </div>
                                <div class="card-info"><h4>Total Licenses</h4></div>
                                <div class="card-glow"></div>
                            </div>
                            <div class="premium-stat-card green">
                                <div class="card-header-compact">
                                    <div class="mini-circular-progress">
                                        <svg viewBox="0 0 100 100">
                                            <circle class="circle-bg" cx="50" cy="50" r="42" />
                                            <circle class="circle-fill" cx="50" cy="50" r="42"
                                                :style="{ 
                                                    strokeDasharray: '263.9', 
                                                    strokeDashoffset: 263.9 * (1 - (stats.total_licenses - stats.active_licenses) / (stats.total_licenses || 1)) 
                                                }"
                                            />
                                        </svg>
                                        <div class="mini-percent">{{ Math.round(((stats.total_licenses - stats.active_licenses) / (stats.total_licenses || 1)) * 100) }}%</div>
                                    </div>
                                    <h2 class="stat-number" style="color: #047857;">{{ stats.active_licenses }}</h2>
                                </div>
                                <div class="card-info"><h4>Available Keys</h4></div>
                                <div class="card-glow"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Modern List Sections -->
                    <div v-if="!showObligationForm" class="admin-content-fade">
                        
                        <!-- Global Action Bar (Above Headings) -->
                        <div v-if="activeTab !== 'stats'" style="display: flex; justify-content: flex-end; padding: 0 2rem 1.5rem 2rem;">
                            <!-- Obligations Action -->
                            <template v-if="activeTab === 'obligations'">
                                <button class="btn-action-premium" @click="openObligationForm">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                    New Compensation Claim
                                </button>
                            </template>
                            <!-- You can add more tab actions here later (e.g. Add User) -->
                        </div>

                        <!-- Column headings. Header and rows share the same
                             .list-cols grid template (per tab), so headings line up
                             with the cells without any positional nudging. -->
                        <div v-if="activeTab !== 'stats' && activeTab !== 'reprocess'" :class="['list-header-row', 'list-cols', 'cols-' + activeTab]">
                            <!-- Team Headers -->
                            <template v-if="activeTab === 'users'">
                                <span class="list-header-cell">User Name</span>
                                <span class="list-header-cell is-center">Email / Role</span>
                                <span class="list-header-cell is-center">Contact Info</span>
                                <span class="list-header-cell is-center">Presence</span>
                            </template>

                            <!-- Bid Headers -->
                            <template v-else-if="activeTab === 'pdfs'">
                                <span class="list-header-cell">Document Name</span>
                                <span class="list-header-cell is-center">Owner / Admin</span>
                                <span class="list-header-cell is-center">Opening Date</span>
                                <span class="list-header-cell is-center">Status</span>
                                <span class="list-header-cell is-center">Action</span>
                            </template>

                            <!-- License Headers -->
                            <template v-else-if="activeTab === 'licenses'">
                                <span class="list-header-cell">License Key</span>
                                <span class="list-header-cell is-center">Assigned To</span>
                                <span class="list-header-cell is-center">Issue Date</span>
                                <span class="list-header-cell is-center">Data Usage</span>
                            </template>

                            <!-- Compensation Claims Headers -->
                            <template v-else-if="activeTab === 'obligations'">
                                <span class="list-header-cell">Obligation Detail</span>
                                <span class="list-header-cell">Recipient</span>
                                <span class="list-header-cell">Penalty / Delay</span>
                                <span class="list-header-cell">Status</span>
                                <span class="list-header-cell is-end">Letter</span>
                            </template>

                            <!-- Email Records Headers -->
                            <template v-else-if="activeTab === 'emails'">
                                <span class="list-header-cell">Subject</span>
                                <span class="list-header-cell">From / Date</span>
                                <span class="list-header-cell">Type</span>
                                <span class="list-header-cell is-end">Actions</span>
                            </template>
                        </div>

                        <!-- User List -->
                        <div v-if="activeTab === 'users'" class="list-container">
                            <div v-for="user in users" :key="user.id" class="list-item-card list-cols cols-users">
                                <div class="user-meta-stack">
                                    <div class="user-visual">{{ user.name.charAt(0) }}</div>
                                    <span class="user-name">{{ user.name }}</span>
                                </div>
                                <div class="user-info-stack" style="text-align: center;">
                                    <span class="stack-name">{{ user.name }}</span>
                                    <span class="stack-email">{{ user.email }}</span>
                                </div>
                                <div class="data-pill" style="margin: 0 auto;">Mobile: {{ user.mobile || '--' }}</div>
                                <div :class="['status-blob', user.is_active ? 'active' : 'disabled']" style="margin: 0 auto;">
                                    <span class="pulse-dot"></span>
                                    {{ user.is_active ? 'Online' : 'Restricted' }}
                                </div>
                            </div>
                            <div v-if="!users.length" class="box-empty"><span class="empty-icon">📂</span><p>No team members yet.</p></div>
                            <AppPagination :currentPage="usersPage" :totalPages="usersTotalPages" @page-changed="fetchUsers" />
                        </div>

                        <!-- Bids List (uploaded bids and their documents) -->
                        <div v-if="activeTab === 'pdfs'" class="list-container">
                            <!-- Project name filter — hidden when the view is locked
                                 to a single project (opened from that project's
                                 details), since there is nothing to search across. -->
                            <div v-if="!scopedPdfId" class="email-filters" style="padding: 1rem 2rem; background: #f8fafc; border-radius: 8px; margin-bottom: 1rem;">
                                <div style="display: grid; grid-template-columns: 2fr 1fr; gap: 1rem; align-items: end;">
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Search Bids</label>
                                        <input type="text" v-model="pdfSearch" @input="onPdfSearchInput"
                                            placeholder="Search by bid name…"
                                            style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;" />
                                    </div>
                                    <div class="input-group">
                                        <button class="btn-action-small" @click="clearPdfSearch" :disabled="!pdfSearch"
                                            style="padding: 0.5rem 0.75rem; width: auto;">
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-for="pdf in allPdfs" :key="pdf.id" class="contract-doc-card">
                                <!-- Project Row -->
                                <div class="contract-doc-row list-cols cols-pdfs" @click="togglePdfExpand(pdf.id)">
                                    <div class="user-meta-stack">
                                        <div class="user-visual" style="background: #fee2e2; color: #dc2626; font-size: 0.7rem; font-weight: 700;">DOC</div>
                                        <div>
                                            <span class="user-name" :title="pdf.pdf_name">{{ cleanPdfName(pdf.pdf_name) }}</span>
                                            <span v-if="pdf.user" style="font-size:0.72rem; color:#64748b; display:block;">{{ pdf.user.email }}</span>
                                        </div>
                                    </div>
                                    <div class="user-info-stack" style="text-align:center;">
                                        <span class="stack-name">{{ pdf.user ? pdf.user.name : 'System' }}</span>
                                    </div>
                                    <div style="display:flex; justify-content:center;">
                                        <div class="data-pill">Opening: {{ formatDate(pdf.bid_opening_date) }}</div>
                                    </div>
                                    <div style="display:flex; justify-content:center;">
                                        <div :class="['status-blob', pdf.is_active ? 'active' : 'disabled']">
                                            <span v-if="pdf.is_active" class="pulse-dot"></span>
                                            {{ pdf.is_active ? 'Active' : 'Archived' }}
                                        </div>
                                    </div>
                                    <div style="display:flex; justify-content:center; align-items:center; gap:0.4rem;">
                                        <button class="btn-action-small" @click.stop="downloadCompanyPdf(pdf.id)" :disabled="downloadingPdfIds.includes(pdf.id)" title="Download All" aria-label="Download all documents">
                                            <template v-if="downloadingPdfIds.includes(pdf.id)">
                                                <svg class="spinner-animate" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
                                            </template>
                                            <template v-else>
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                            </template>
                                        </button>
                                        <!-- Expand chevron -->
                                        <svg v-if="postBidEnabled" :style="{ transform: expandedPdfId === pdf.id ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s', color: '#64748b' }" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
                                    </div>
                                </div>

                                <!-- Folder Tree (expanded) -->
                                <transition name="expand">
                                    <div v-if="expandedPdfId === pdf.id" class="folder-tree-wrapper">
                                        <div v-for="folder in getDummyFolders(pdf.id)" :key="folder.name" class="folder-block">
                                            <!-- Folder Header -->
                                            <div class="folder-header" @click="toggleFolder(pdf.id, folder.name)">
                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" style="color:#f59e0b; flex-shrink:0;"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
                                                <span class="folder-name">{{ folder.name }}</span>
                                                <span v-if="folder.name === 'Contract Documents' && contractFiles[pdf.id]" class="folder-count">{{ contractFiles[pdf.id].length }} files</span>
                                                <span v-if="folder.name === 'Obligation Documents' && obligationFiles[pdf.id]" class="folder-count">{{ obligationFiles[pdf.id].length }} files</span>
                                                <svg :style="{ transform: isFolderOpen(pdf.id, folder.name) ? 'rotate(90deg)' : 'rotate(0)', transition:'transform 0.2s', marginLeft:'auto', color:'#64748b' }" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
                                            </div>
                                            <!-- Files inside folder -->
                                            <transition name="expand">
                                                <div v-if="isFolderOpen(pdf.id, folder.name)" class="file-list">
                                                    <!-- Contract Documents — real data -->
                                                    <template v-if="folder.name === 'Contract Documents'">
                                                        <div v-if="loadingContractFiles[pdf.id]" class="file-row" style="color:#64748b; font-size:0.8rem; justify-content:center; padding:0.75rem 1rem;">
                                                            Loading files...
                                                        </div>
                                                        <div v-else-if="!contractFiles[pdf.id] || contractFiles[pdf.id].length === 0" class="file-row" style="color:#64748b; font-size:0.8rem; justify-content:center; padding:0.75rem 1rem;">
                                                            No documents uploaded yet
                                                        </div>
                                                        <div v-else v-for="file in contractFiles[pdf.id]" :key="file.id" class="file-row">
                                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color:#dc2626; flex-shrink:0;"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                                            <span class="file-name">{{ file.name }}</span>
                                                            <span class="file-size" style="color:#64748b; font-size:0.72rem; margin-left:auto;">{{ formatDate(file.date) }}</span>
                                                            <button class="file-download-btn" @click="downloadMailPdf(file.id)" title="Download" :aria-label="`Download ${file.name}`">
                                                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                                            </button>
                                                        </div>
                                                    </template>
                                                    <!-- Obligation Documents — real data -->
                                                    <template v-else>
                                                        <div v-if="loadingObligationFiles[pdf.id]" class="file-row" style="color:#64748b; font-size:0.8rem; justify-content:center; padding:0.75rem 1rem;">
                                                            Loading files...
                                                        </div>
                                                        <div v-else-if="!obligationFiles[pdf.id] || obligationFiles[pdf.id].length === 0" class="file-row" style="color:#64748b; font-size:0.8rem; justify-content:center; padding:0.75rem 1rem;">
                                                            No obligation letters generated yet
                                                        </div>
                                                        <div v-else v-for="file in obligationFiles[pdf.id]" :key="file.id" class="file-row">
                                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color:#dc2626; flex-shrink:0;"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                                            <span class="file-name" :title="file.obligation">{{ file.name }}</span>
                                                            <span class="file-size" style="color:#64748b; font-size:0.72rem; margin-left:auto;">{{ formatDate(file.date) }}</span>
                                                            <button class="file-download-btn" @click="downloadObligationPdf(file.id)" title="Download" :aria-label="`Download ${file.name}`">
                                                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <div v-if="!allPdfs.length" class="box-empty">
                                <span class="empty-icon">📄</span>
                                <p v-if="scopedPdfId">This bid wasn’t found. It may have been deleted.</p>
                                <p v-else-if="pdfSearch.trim()">No bids match "<strong>{{ pdfSearch.trim() }}</strong>".</p>
                                <p v-else>No bids uploaded yet.</p>
                            </div>
                            <AppPagination v-if="!scopedPdfId" :currentPage="pdfsPage" :totalPages="pdfsTotalPages" @page-changed="applyPdfView" />
                        </div>

                        <!-- License List -->
                        <div v-if="activeTab === 'licenses'" class="list-container">
                            <div v-for="lic in licenses" :key="lic.id" class="list-item-card list-cols cols-licenses">
                                <div class="key-wrapper">
                                    <div class="key-container" @click="copyKey(lic.license, lic.id)">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4facfe" stroke-width="2.5"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
                                        <span class="key-text">{{ lic.license }}</span>
                                    </div>
                                    <transition name="pop">
                                        <span v-if="copiedId === lic.id" class="copy-toast">Copied!</span>
                                    </transition>
                                </div>
                                <div class="user-info-stack" style="text-align: center;">
                                    <span v-if="lic.user" class="stack-name">{{ lic.user.name }}</span>
                                    <span v-if="lic.user" class="stack-email">{{ lic.user.email }}</span>
                                    <span v-else class="user-email">Unassigned Code</span>
                                </div>
                                <div class="premium-date" style="text-align: center;">{{ formatDate(lic.created_date) }}</div>
                                <div :class="['status-blob', lic.is_active ? 'active' : 'disabled']" :style="{ margin: '0 auto', background: lic.is_active ? '#dcfce7' : '#fee2e2', color: lic.is_active ? '#166534' : '#991b1b' }">
                                    <span v-if="lic.is_active" class="pulse-dot" style="background: #166534;"></span>
                                    {{ lic.is_active ? 'Ready' : 'Consumed' }}
                                </div>
                            </div>
                            <div v-if="!licenses.length" class="box-empty"><span class="empty-icon">🔑</span><p>No licenses yet.</p></div>
                            <AppPagination :currentPage="licensesPage" :totalPages="licensesTotalPages" @page-changed="fetchLicenses" />
                        </div>

                        <!-- Obligations List -->
                        <div v-if="activeTab === 'obligations'" class="list-container">

                            <!-- Filters -->
                            <div class="email-filters" style="padding: 1rem 2rem; background: #f8fafc; border-radius: 8px; margin-bottom: 1rem;">
                                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem; align-items: end;">
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Project</label>
                                        <select v-model="obligationFilters.project_id" @change="fetchObligations()" :disabled="isProjectScoped" :class="{ 'disabled-select': isProjectScoped }" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;">
                                            <option v-if="!isProjectScoped" value="">All Projects</option>
                                            <option v-for="pdf in allPdfsDropdown" :key="pdf.id" :value="pdf.id">{{ stripPdfExt(pdf.pdf_name) }}</option>
                                        </select>
                                    </div>
                                    <!-- <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Letter Status</label>
                                        <select v-model="obligationFilters.letter_required" @change="fetchObligations()" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;">
                                            <option value="">All</option>
                                            <option value="true">Letter Required</option>
                                            <option value="false">No Letter</option>
                                        </select>
                                    </div>
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Search</label>
                                        <input type="text" v-model="obligationFilters.content_search" @input="fetchObligations()" placeholder="Search obligation / description..." style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;" />
                                    </div> -->
                                </div>
                            </div>

                            <div v-for="obl in obligations" :key="obl.id" class="list-item-card list-cols cols-obligations">
                                <div class="user-meta-stack">
                                    <div class="user-visual" style="background: #fffbeb; color: #d97706; font-size: 1rem;">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="20" height="20"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                                    </div>
                                    <span class="user-name" :title="obl.failure_description">{{ obl.obligation }}</span>
                                </div>
                                <div class="user-info-stack">
                                    <span class="stack-name">To: {{ obl.send_to || 'N/A' }}</span>
                                    <span class="stack-email">{{ cleanPdfName(allPdfsDropdown.find(p => p.id === obl.pdf_id)?.pdf_name) || 'PDF #' + obl.pdf_id }}</span>
                                </div>
                                <div class="data-pill">Penalty: ₹{{ obl.settlement_amount || 0 }} ({{ obl.no_of_day_delays || 0 }} d)</div>
                                <div :class="['status-blob', obl.letter_required ? 'disabled' : 'active']" :style="{ background: obl.letter_required ? '#fee2e2' : '#f1f5f9', color: obl.letter_required ? '#991b1b' : '#64748b' }">
                                    <span v-if="obl.letter_required" class="pulse-dot"></span>
                                    {{ obl.letter_required ? 'Letter Req' : 'No Letter' }}
                                </div>
                                <!-- Download the generated delay letter for this row.
                                     pdf_letter_name is empty until the background
                                     letter generation finishes, so show a muted
                                     "Generating…" hint instead of a dead link. -->
                                <div class="obligation-letter-cell">
                                    <button v-if="obl.pdf_letter_name" class="btn-action-small"
                                        @click="downloadObligationLetter(obl.id)"
                                        :disabled="downloadingObligationIds.includes(obl.id)"
                                        :title="'Download ' + obl.pdf_letter_name.replace(/\\/g, '/').split('/').pop()"
                                        style="display:inline-flex; align-items:center; gap:0.35rem; padding:0.35rem 0.7rem; width:auto;">
                                        <svg v-if="!downloadingObligationIds.includes(obl.id)" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7,10 12,15 17,10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                        <svg v-else class="spinner-animate" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round">
                                            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                                        </svg>
                                        {{ downloadingObligationIds.includes(obl.id) ? 'Downloading…' : 'Letter' }}
                                    </button>
                                    <span v-else-if="obl.letter_required" style="font-size:0.72rem; color:#64748b; font-style:italic;">
                                        Generating…
                                    </span>
                                    <span v-else style="font-size:0.72rem; color:#64748b;">—</span>
                                </div>
                            </div>
                            <div v-if="!obligations.length" class="box-empty"><span class="empty-icon">📝</span><p>No compensation claims yet.</p></div>
                        </div>

                        <!-- Email Records List -->
                        <div v-if="activeTab === 'emails'" class="list-container">
                            <!-- Filters Section -->
                            <div class="email-filters" style="padding: 1rem 2rem; background: #f8fafc; border-radius: 8px; margin-bottom: 1rem;">
                                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr; gap: 1rem; align-items: end;">
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Project</label>
                                        <select v-model="emailFilters.project_id" @change="fetchEmailRecords(1)" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;">
                                            <option value="">All Projects</option>
                                            <option v-for="pdf in allPdfsDropdown" :key="pdf.id" :value="pdf.id">{{ stripPdfExt(pdf.pdf_name) }}</option>
                                        </select>
                                    </div>
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Content Search</label>
                                        <input type="text" v-model="emailFilters.content_search" @input="fetchEmailRecords(1)" placeholder="Search subject/body" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;" />
                                    </div>
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Email Type</label>
                                        <select v-model="emailFilters.email_type" @change="fetchEmailRecords(1)" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;">
                                            <option value="">All Types</option>
                                            <option value="query">Query</option>
                                            <option value="appreciation">Appreciation</option>
                                            <option value="thank_you">Thank You</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Start Date</label>
                                        <input type="date" v-model="emailFilters.start_date" @change="fetchEmailRecords(1)" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;">
                                    </div>
                                    <div class="input-group">
                                        <label style="font-size: 0.75rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">End Date</label>
                                        <input type="date" v-model="emailFilters.end_date" @change="fetchEmailRecords(1)" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 4px;">
                                    </div>
                                </div>
                            </div>

                            <div v-for="email in emailRecords" :key="email.id" class="list-item-card list-cols cols-emails">
                                <div class="user-meta-stack">
                                    <div class="user-visual" style="background: #e0f2fe; color: #0369a1;">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                                    </div>
                                    <span class="user-name" :title="email.email_subject">{{ email.email_subject }}</span>
                                </div>
                                <div class="user-info-stack">
                                    <span class="stack-name">{{ email.email_from }}</span>
                                    <span class="stack-email">{{ formatDate(email.email_date) }}</span>
                                </div>
                                <div class="data-pill">{{ email.email_type }}</div>
                                <div class="action-buttons">
                                    <button class="btn-action-small" @click="viewEmailDetail(email.id)" title="View Details" aria-label="View email details">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                    </button>
                                    <button v-if="email.has_file" class="btn-action-small" @click="downloadMailPdf(email.id)" :disabled="downloadingEmailIds.includes(email.id)" title="Download PDF" aria-label="Download PDF">
                                        <template v-if="downloadingEmailIds.includes(email.id)">
                                            <svg class="spinner-animate" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
                                        </template>
                                        <template v-else>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                        </template>
                                    </button>
                                    <button class="btn-action-small danger" @click="deleteEmailRecord(email.id)" title="Delete" aria-label="Delete email record">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3,6 5,6 21,6"/><path d="M19,6v14a2,2 0 0,1-2,2H7a2,2 0 0,1-2-2V6m3,0V4a2,2 0 0,1,2-2h4a2,2 0 0,1,2,2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
                                    </button>
                                </div>
                            </div>
                            <div v-if="!emailRecords.length" class="box-empty"><span class="empty-icon">📧</span><p>No email records found.</p></div>
                            <AppPagination :currentPage="emailRecordsPage" :totalPages="emailRecordsTotalPages" @page-changed="fetchEmailRecords" />
                        </div>

                        <!-- Reprocessing (Admin only) -->
                        <div v-if="activeTab === 'reprocess'" class="list-container">
                            <div class="reprocess-intro">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="23 4 23 10 17 10"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/></svg>
                                <div>
                                    <h4>AI Reprocessing</h4>
                                    <p>Re-run an AI step for a selected bid. Each job runs in the background; you'll be notified when it finishes.</p>
                                </div>
                            </div>

                            <div class="reprocess-picker">
                                <label>Select Bid</label>
                                <select v-model="reprocessPdfId">
                                    <option :value="null" disabled>Choose a bid document…</option>
                                    <option v-for="pdf in allPdfsDropdown" :key="pdf.id" :value="pdf.id">{{ stripPdfExt(pdf.pdf_name) }}</option>
                                </select>
                            </div>

                            <div v-if="reprocessPdfId" class="reprocess-grid">
                                <div v-for="action in reprocessActions" :key="action.key" class="reprocess-card">
                                    <div class="reprocess-card-text">
                                        <span class="reprocess-name">{{ action.label }}</span>
                                        <span class="reprocess-desc">{{ action.desc }}</span>
                                    </div>
                                    <button class="btn-reprocess" :disabled="reprocessBusy[action.key]" @click="runReprocess(action)">
                                        <svg v-if="reprocessBusy[action.key]" class="spinner-animate" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
                                        <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="23 4 23 10 17 10"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/></svg>
                                        {{ reprocessBusy[action.key] ? 'Starting…' : 'Run' }}
                                    </button>
                                </div>
                            </div>
                            <div v-else class="box-empty"><span class="empty-icon">🔄</span><p>Select a bid above to see reprocessing actions.</p></div>
                        </div>
                    </div> <!-- End of modern list sections -->

                    <!-- PROFESSIONAL FORM UI (FULL PAGE MODE) -->
                    <transition name="fade">
                        <div v-if="showObligationForm" class="premium-form-card full-page-form">
                            <button type="button" class="btn-cancel-floating" @click="closeObligationForm">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                                    <line x1="19" y1="12" x2="5" y2="12"></line>
                                    <polyline points="12 19 5 12 12 5"></polyline>
                                </svg>
                                {{ obligationFormFromRoute ? 'Back to Bid' : 'Back' }}
                            </button>

                            <div class="form-header">
                                <div class="header-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                                </div>
                                <div class="header-text">
                                    <h3>New Compensation Claim</h3>
                                    <p>Record the performance failure and generate the formal notice.</p>
                                </div>
                            </div>

                            <form @submit.prevent="submitObligationForm" class="pro-form">
                                <div class="form-section">
                                    <h4 class="section-title">1. Context & Categorization</h4>
                                    <div class="form-col-stack">
                                        <div class="input-group">
                                            <label>Relative PDF Context</label>
                                            <div class="input-wrapper">
                                                <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                            <select v-model="formData.pdf_id" required :disabled="isPdfPreSelected" :class="{'disabled-select': isPdfPreSelected}" @change="onPdfSelect">
                                                <option value="" disabled>Link associated document...</option>
                                                <option v-for="pdf in allPdfsDropdown" :key="pdf.id" :value="pdf.id">
                                                    {{ stripPdfExt(pdf.pdf_name) }} (#{{ pdf.id }})
                                                </option>
                                            </select>
                                            </div>
                                        </div>
                                        <div class="input-group">
                                            <label>Obligation Stream</label>
                                            <div class="input-wrapper">
                                                <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
                                                <select v-model="formData.obligation_id" @change="onObligationSelect" required>
                                                    <option value="" disabled>Select obligation type...</option>
                                                    <option v-for="obs in performanceObligationsList" :key="obs.id" :value="obs.id">
                                                        {{ obs.obligation }}
                                                    </option>
                                                    <option value="-1">Other</option>
                                                </select>
                                            </div>
                                            <!-- add new input field for obligation description if "Other" is selected -->
                                            <div v-if="formData.obligation_id === '-1'" class="input-group">
                                                <label>Obligation Description</label>
                                                <div class="input-wrapper">
                                                    <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                                                    <input type="text" v-model="formData.other_obligation" placeholder="Enter obligation description..." required />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="form-section">
                                    <h4 class="section-title">2. Correspondence Details</h4>
                                    <div class="form-col-stack">
                                        <!-- <div class="input-group">
                                            <label>Highlight Text (Mail Subject)</label>
                                            <div class="input-wrapper">
                                                <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                                                <input type="text" v-model="formData.obligation" placeholder="Key failure clause description..." required />
                                            </div>
                                        </div>
                                        <div class="input-group">
                                            <label>Recipient Address</label>
                                            <div class="input-wrapper">
                                                <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                                                <input type="email" v-model="formData.send_to" placeholder="contractor@agency.com" required />
                                            </div> -->
                                        <!-- </div> -->
                                        <div class="input-group full-width">
                                            <label>Technical Root Cause & Description</label>
                                            <div class="input-wrapper text-area">
                                                <textarea v-model="formData.failure_description" rows="3" placeholder="Provide detailed technical background for the mail body..." required></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-section">
                                    <h4 class="section-title">3. Metrics & Timeline</h4>
                                    <div class="form-col-stack">
                                        <div class="input-group">
                                            <label>Failure Date</label>
                                            <div class="input-wrapper">
                                                <input type="date" v-model="formData.obligation_failure_date" required />
                                            </div>
                                        </div>
                                        <div class="input-group">
                                            <label>SLA Delay</label>
                                            <div class="input-wrapper suffix">
                                                <input type="number" v-model="formData.no_of_day_delays" required min="0" />
                                                <span class="input-suffix">days</span>
                                            </div>
                                        </div>
                                        <div class="input-group">
                                            <label>Settlement Amount</label>
                                            <div class="input-wrapper prefix">
                                                <span class="input-prefix">₹</span>
                                                <input type="number" v-model="formData.settlement_amount" required min="0" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-footer-actions">
                                    <label class="custom-checkbox-premium">
                                        <input type="checkbox" v-model="formData.letter_required" />
                                        <span class="checkmark-box"></span>
                                        <div class="check-text">
                                            <span class="check-title">Generate Official PDF Letter</span>
                                            <span class="check-sub">Automated formal notice construction</span>
                                        </div>
                                    </label>

                                    <button type="submit" class="btn-submit-pro" :disabled="isSubmittingObligation">
                                        <template v-if="isSubmittingObligation">
                                            <svg class="spinner-animate" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
                                            <span>Processing...</span>
                                        </template>
                                        <template v-else>
                                            <span>Save Claim and Notify</span>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                                        </template>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </transition>
                </div>
            </section>
        </main>

        <!-- Email detail sheet -->
        <div v-if="emailDetail" class="email-detail-overlay" @click.self="emailDetail = null">
            <div class="email-detail-sheet" role="dialog" aria-modal="true" aria-labelledby="email-detail-title">
                <div class="email-detail-head">
                    <h3 id="email-detail-title">{{ emailDetail.email_subject || 'No subject' }}</h3>
                    <button type="button" class="email-detail-close" aria-label="Close" @click="emailDetail = null">&times;</button>
                </div>
                <dl class="email-detail-meta">
                    <dt>From</dt><dd>{{ emailDetail.email_from || '—' }}</dd>
                    <dt>Date</dt><dd>{{ formatDate(emailDetail.email_date) }}</dd>
                    <dt>Type</dt><dd>{{ emailDetail.email_type || '—' }}</dd>
                </dl>
                <div class="email-detail-body">{{ emailDetail.email_body || 'No body available.' }}</div>
                <div class="email-detail-foot">
                    <button type="button" class="btn-cancel-floating" @click="emailDetail = null">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import AppSidebar from './Sidebar.vue';
import AppPagination from './AppPagination.vue';
import { notify } from '@/utils/notify';
import { confirmAction } from '@/utils/confirm';
import { POST_BID_ENABLED } from '@/config/features';

export default {
    name: 'CompanyAdmin',
    components: { AppSidebar, AppPagination },
    props: {
        getAccessToken: Function,
        headerVisiblity: Function
    },
    data() {
        return {
            // Compensation Claims, Email Records and the per-bid document
            // folders are post-bid; hidden while it's off (config/features.js).
            postBidEnabled: POST_BID_ENABLED,
            activeTab: 'stats',
            stats: { total_users: 0, total_pdfs: 0, total_licenses: 0, active_licenses: 0 },
            users: [],
            licenses: [],
            allPdfs: [],
            allPdfsDropdown: [],
            // Full slim list fetched ONCE from /user/get-pdf-admin. The paginated
            // table (allPdfs) and the id/name dropdowns (allPdfsDropdown) are both
            // derived from this in-memory list, so the admin panel hits the API
            // only once instead of twice.
            allPdfsMaster: [],
            pdfsPageSize: 10,
            // Contract Docs → project name filter (applied client-side over allPdfsMaster)
            pdfSearch: '',
            pdfSearchTimeout: null,
            // When opened from Active Project → Project Details → Contract Documents,
            // the view is locked to that one project (id from ?project_id=).
            scopedPdfId: null,
            obligations: [],
            performanceObligationsList: [],
            adminInfo: null,
            isPdfPreSelected: false,
            isProjectScoped: false,
            usersPage: 1,
            usersTotalPages: 1,
            pdfsPage: 1,
            pdfsTotalPages: 1,
            licensesTotalPages: 1,
            copiedId: null,
            showObligationForm: false,
            // True when the Generate Mail & Record form was opened by a deep-link
            // from a project's Compensation Claim portlet (?tab=obligations&pdf_id=).
            // Decides whether "Back" navigates to that project or just closes the form.
            obligationFormFromRoute: false,
            emailRecords: [],
            // Email record shown in the detail sheet (null = closed).
            emailDetail: null,
            emailRecordsPage: 1,
            emailRecordsTotalPages: 1,
            // --- AI Reprocessing tab ---
            reprocessPdfId: null,
            reprocessBusy: {},
            reprocessActions: [
                { key: 'reingest', label: 'Re-ingest Document', desc: 'Rebuild vectors and regenerate the full summary, criteria, risk & KB match.', url: '/user/restore-upload-pdf' },
                { key: 'summary', label: 'Repopulate Summary', desc: 'Regenerate the head-wise bid summary (also re-runs basic data, criteria, risk & match).', url: '/user/populate-pdf-summary' },
                { key: 'basic', label: 'Repopulate Basic Data', desc: 'Re-extract name of work, estimated cost, dates and contact person.', url: '/user/repopulate-basic-data' },
                { key: 'criteria', label: 'Re-extract Acceptance Criteria', desc: 'Re-run technical & financial eligibility criteria extraction.', url: '/user/restore-acceptance-criteria' },
                { key: 'risk', label: 'Recalculate Risk Assessment', desc: 'Re-score the 15 contractual/commercial risks.', url: '/user/recalculate-risk-assessment' },
                { key: 'match', label: 'Re-match Criteria with KB', desc: 'Recompute the match between criteria and the company knowledge base.', url: '/user/match-criteria-kb' },
                { key: 'obligation', label: 'Repopulate Obligations', desc: 'Clear and re-extract the development & operation obligations for this bid.', url: '/user/restore-obligations' },
                { key: 'deliverables', label: 'Re-extract Deliverables', desc: 'Clear and re-extract the time-bound contractor deliverables & milestones (with deadlines).', url: '/user/restore-deliverables' },
            ],
            obligationFilters: {
                project_id: "",
                letter_required: "",
                content_search: ""
            },
            emailFilters: {
                project_id: "",
                email_type: "",
                start_date: "",
                end_date: "",
                content_search: ""
            },
            formData: {
                pdf_id: "",
                obligation_id: "",
                obligation: "",
                send_to: "",
                failure_description: "",
                letter_required: true,
                obligation_failure_date: "",
                no_of_day_delays: 1,
                settlement_amount: 0,
                other_obligation: ""
            },
            downloadingPdfIds: [],
            downloadingEmailIds: [],
            // Per-row spinner state for the obligation letter downloads.
            downloadingObligationIds: [],
            isSubmittingObligation: false,
            expandedPdfId: null,
            openFolders: {},
            contractFiles: {},
            loadingContractFiles: {},
            obligationFiles: {},
            loadingObligationFiles: {}
        }
    },
    async mounted() {
        this.headerVisiblity(true);
        await this.fetchAdminInfo();
        this.initFromRoute();
    },
    computed: {
        // Keep the sidebar on whatever section we were opened from (e.g. a
        // post-bid project's contract-docs / obligations view); default to Admin.
        sidebarActive() {
            const from = String(this.$route.query.from || '').trim();
            const allowed = ['tenders', 'bookmarks', 'files', 'upload', 'active', 'completed', 'knowledge', 'admin', 'dashboard'];
            return allowed.includes(from) ? from : 'admin';
        },
        // The admin tab dock (Overview / Team / Licenses / Reprocessing…) belongs
        // to the Admin section only. When a bid drills into a specific view
        // (contract docs, obligations, emails) the sidebar stays on that bid's
        // section, so hide the full admin navigation and show just that content.
        cameFromAdmin() {
            return this.sidebarActive === 'admin';
        },
        // The bid this view was opened from (deep link with ?project_id= or
        // ?pdf_id=). Drives the "Back to Bid" button.
        backToBidId() {
            const q = this.$route.query || {};
            const id = Number(q.project_id || q.pdf_id);
            return Number.isFinite(id) && id > 0 ? id : null;
        }
    },
    watch: {
        activeTab(newTab) {
            if (newTab === 'emails') {
                this.fetchEmailRecords();
            }
        },
        // Vue REUSES this component when navigating to the same route with a
        // different (or absent) query — e.g. clicking "Admin Panel" in the
        // sidebar while a project-scoped Contract Docs view is open. mounted()
        // does not run again, so without this the scoped state persisted and the
        // admin panel kept showing the single project. Re-initialising on every
        // query change lands the user on a clean Overview with default values.
        '$route.query': {
            deep: true,
            handler() {
                this.initFromRoute();
            },
        },
    },
    methods: {
        fetchAllData() {
            this.fetchStats();
            this.fetchUsers();
            this.fetchLicenses();
            this.fetchCompanyPdfs();
            if (!POST_BID_ENABLED) return;
            this.fetchObligations();
            this.fetchPerformanceObligations();
            if (this.activeTab === 'emails') {
                this.fetchEmailRecords();
            }
        },
        async fetchAdminInfo() {
            try {
                const res = await axios.get(this.$API_URL + "/company_admin/me", {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.adminInfo = res.data;
            } catch (e) { console.error(e); }
        },
        async fetchStats() {
            try {
                const res = await axios.get(this.$API_URL + "/company_admin/stats", {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.stats = res.data;
            } catch (e) { console.error(e); }
        },
        async fetchUsers(page = 1) {
            try {
                this.usersPage = page;
                const res = await axios.get(this.$API_URL + `/company_admin/users?page=${page}&page_size=10`, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.users = res.data.items || [];
                this.usersTotalPages = res.data.total_pages || 1;
            } catch (e) { console.error(e); }
        },
        // Apply the current route query to the view. Called on mount AND whenever
        // the query changes (the component is reused across those navigations).
        // Every piece of deep-link state is reset first, so arriving with no
        // query — e.g. sidebar → Admin Panel — always yields a clean Overview
        // with default values rather than the previous project-scoped view.
        initFromRoute() {
            const q = this.$route.query || {};

            // 1) Reset all deep-link/scoped state.
            this.scopedPdfId = null;
            this.isProjectScoped = false;
            this.isPdfPreSelected = false;
            this.showObligationForm = false;
            this.obligationFormFromRoute = false;
            this.expandedPdfId = null;
            this.openFolders = {};
            this.contractFiles = {};
            this.obligationFiles = {};
            this.pdfSearch = '';
            this.pdfsPage = 1;
            this.obligationFilters.project_id = '';
            this.emailFilters.project_id = '';
            const postBidTab = q.tab === 'obligations' || q.tab === 'emails';
            this.activeTab = (postBidTab && !POST_BID_ENABLED) ? 'stats' : (q.tab || 'stats');

            // 2) Resolve the Contract Docs project scope BEFORE fetchAllData():
            // it calls fetchCompanyPdfs(), and if the scope were applied after,
            // the unscoped request could resolve last and overwrite the
            // single-project list with every project (intermittent bug).
            if (q.tab === 'pdfs' && q.project_id) {
                this.scopedPdfId = Number(q.project_id);
                this.isProjectScoped = true;
            }

            this.fetchAllData();

            // 3) Navigated from a project's Compensation Claim portlet with a
            //    specific PDF to generate mail for. Remember that origin so the
            //    form's Back button returns to that project.
            if (!POST_BID_ENABLED) return;
            if (q.pdf_id) {
                this.showObligationForm = true;
                this.formData.pdf_id = Number(q.pdf_id);
                this.isPdfPreSelected = true;
                this.obligationFormFromRoute = true;
            }

            // 4) Deep-link from BidDetails (Email Records / Obligations).
            if (q.tab === 'emails') {
                if (q.project_id) this.emailFilters.project_id = String(q.project_id);
                this.fetchEmailRecords();
            }
            if (q.tab === 'obligations' && q.project_id) {
                this.obligationFilters.project_id = Number(q.project_id);
                this.isProjectScoped = true;
                this.fetchObligations();
            }
        },
        // Fetch the company's bids ONCE (slim payload: id, pdf_name,
        // project_name, opening date, active, uploader) and derive everything
        // the admin panel needs from that single in-memory list:
        //   • allPdfsDropdown — full id/name list for the obligation/email/mail
        //     dropdowns,
        //   • allPdfs — the current page of the Contract Documents table.
        // Search and pagination are applied client-side, so this endpoint is
        // hit only on (re)load — not on every page change or keystroke.
        async fetchCompanyPdfs(page = 1) {
            try {
                const res = await axios.get(
                    this.$API_URL + `/user/get-pdf-admin?page=1&page_size=1000`,
                    { headers: { Authorization: 'Bearer ' + this.getAccessToken() } }
                );
                this.allPdfsMaster = res.data.items || [];
                // Dropdowns always show every project, regardless of table filters.
                this.allPdfsDropdown = this.allPdfsMaster;
                this.applyPdfView(page);
            } catch (e) { console.error(e); }
        },
        // Rebuild the paginated table from the already-fetched master list.
        // No network call — used for page changes, search and clearing search.
        applyPdfView(page = 1) {
            // Scoped view (opened from a specific project): show only that row.
            if (this.scopedPdfId) {
                this.allPdfs = this.allPdfsMaster.filter(
                    p => Number(p.id) === Number(this.scopedPdfId)
                );
                this.pdfsPage = 1;
                this.pdfsTotalPages = 1;
                if (this.allPdfs.length) {
                    const id = this.allPdfs[0].id;
                    this.expandedPdfId = id;
                    const key = `${id}_Contract Documents`;
                    this.openFolders = { ...this.openFolders, [key]: true };
                    this.fetchContractFiles(id);
                }
                return;
            }

            const q = this.pdfSearch.trim().toLowerCase();
            const filtered = q
                ? this.allPdfsMaster.filter(p => (p.pdf_name || '').toLowerCase().includes(q))
                : this.allPdfsMaster;

            const size = this.pdfsPageSize;
            const totalPages = Math.max(1, Math.ceil(filtered.length / size));
            const current = Math.min(Math.max(1, page), totalPages);
            const start = (current - 1) * size;

            this.pdfsPage = current;
            this.pdfsTotalPages = totalPages;
            this.allPdfs = filtered.slice(start, start + size);
        },
        onPdfSearchInput() {
            // Debounce the client-side filter so the table isn't rebuilt on every
            // keystroke. Always reset to page 1 — the result set changes.
            clearTimeout(this.pdfSearchTimeout);
            this.pdfSearchTimeout = setTimeout(() => this.applyPdfView(1), 250);
        },
        clearPdfSearch() {
            this.pdfSearch = '';
            clearTimeout(this.pdfSearchTimeout);
            this.applyPdfView(1);
        },
        async runReprocess(action) {
            if (!this.reprocessPdfId) {
                notify.warning('Select a bid first.');
                return;
            }
            const ok = await confirmAction({
                title: `${action.label}?`,
                message: `${action.desc} Existing results for this bid are replaced.`,
                confirmLabel: action.label,
            });
            if (!ok) return;
            this.reprocessBusy[action.key] = true;
            try {
                const url = `${this.$API_URL}${action.url}?pdf_id=${this.reprocessPdfId}`;
                await axios.post(url, {}, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                notify.success(`${action.label} started. You’ll be notified when it finishes.`);
            } catch (e) {
                notify.error(`Couldn’t start ${action.label}: ${e.response?.data?.detail || e.message}. Try again.`);
            } finally {
                this.reprocessBusy[action.key] = false;
            }
        },
        async fetchLicenses(page = 1) {
            try {
                this.licensesPage = page;
                const res = await axios.get(this.$API_URL + `/company_admin/licenses?page=${page}&page_size=10`, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.licenses = res.data.items || [];
                this.licensesTotalPages = res.data.total_pages || 1;
            } catch (e) { console.error(e); }
        },
        // Back to the bid this view was opened from, on its Project tab. The
        // sidebar section (`from`) is carried over so it keeps its highlight.
        goBackToBid(id = this.backToBidId) {
            if (!id) {
                this.$router.push({ name: 'CompanyAdmin', query: {} });
                return;
            }
            const from = this.sidebarActive;
            const query = { tab: 'project' };
            if (from === 'completed') query.status = 'COMPLETED';
            else if (from !== 'files') query.status = 'WIN';
            if (from !== 'admin') query.from = from;
            this.$router.push({ name: 'BidDetails', params: { pdf_id: id }, query });
        },
        // Download the delay letter generated for one obligation-failure record.
        // Reuses the existing admin endpoint, which streams a PDF (or a ZIP when
        // the record has several files).
        async downloadObligationLetter(obligationId) {
            if (this.downloadingObligationIds.includes(obligationId)) return;
            this.downloadingObligationIds.push(obligationId);
            try {
                const res = await axios.get(
                    `${this.$API_URL}/company_admin/download-obligation/${obligationId}`,
                    { headers: { Authorization: 'Bearer ' + this.getAccessToken() }, responseType: 'blob' }
                );
                const contentType = res.headers['content-type'] || res.headers['Content-Type'] || 'application/octet-stream';
                const isZip = contentType.includes('zip');
                let filename = isZip ? `obligation_files_${obligationId}.zip` : `obligation_letter_${obligationId}.pdf`;
                const disp = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                if (disp) {
                    const m = disp.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)/i);
                    if (m && m[1]) filename = decodeURIComponent(m[1].replace(/['"]/g, ''));
                }
                const blob = new Blob([res.data], { type: contentType });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                setTimeout(() => URL.revokeObjectURL(url), 100);
            } catch (e) {
                console.error('Failed to download obligation letter', e);
                notify.error('Couldn’t download the letter. It may still be generating — try again in a minute.');
            } finally {
                this.downloadingObligationIds = this.downloadingObligationIds.filter(id => id !== obligationId);
            }
        },
        async fetchObligations() {
            try {
                let url = this.$API_URL + "/company_admin/performance-obligations-failures";
                const params = [];
                if (this.obligationFilters.project_id)
                    params.push(`pdf_id=${this.obligationFilters.project_id}`);
                if (this.obligationFilters.letter_required !== "")
                    params.push(`letter_required=${this.obligationFilters.letter_required}`);
                if (this.obligationFilters.content_search)
                    params.push(`search=${encodeURIComponent(this.obligationFilters.content_search)}`);
                if (params.length) url += "?" + params.join("&");
                const res = await axios.get(url, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.obligations = res.data || [];
            } catch (e) { console.error(e); }
        },
        async fetchPerformanceObligations() {
            try {
                let pdf_id = this.$route.query.pdf_id || this.formData.pdf_id;
                let url = this.$API_URL + "/company_admin/performance-obligation";
                if (pdf_id) {
                    url += "?pdf_id=" + pdf_id;
                }
                const res = await axios.get(url, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.performanceObligationsList = res.data || [];
            } catch (e) { console.error(e); }
        },
        onObligationSelect() {
            const selected = this.performanceObligationsList.find(o => o.id === this.formData.obligation_id);
            if (selected) {
                this.formData.obligation = selected.obligation;
            }
        },
        onPdfSelect:function() {
            this.fetchPerformanceObligations();
        },
        // "Back" on the Generate Mail & Record form. This form is reached from two
        // places and must return to whichever one opened it:
        //   1. Project details → Compensation Claim → Generate Mail & Record
        //      (deep-link: ?tab=obligations&pdf_id=X) → go back to that project.
        //   2. Admin panel → Obligations → Generate Mail & Record
        //      (opened in place, no navigation) → just close the form.
        closeObligationForm() {
            if (this.obligationFormFromRoute) {
                this.obligationFormFromRoute = false;
                const id = this.formData.pdf_id || this.backToBidId;
                if (id) {
                    this.goBackToBid(id);
                } else {
                    this.showObligationForm = false;
                }
                return;
            }
            // Opened from within the admin panel — just close it.
            this.showObligationForm = false;
        },
        openObligationForm() {
            // When scoped to a single project (arrived via Active Project →
            // Project Details → Obligations), pre-select and lock that project so
            // the detail form only deals with the respective project's data.
            if (this.isProjectScoped && this.obligationFilters.project_id) {
                this.formData.pdf_id = Number(this.obligationFilters.project_id);
                this.isPdfPreSelected = true;
                this.fetchPerformanceObligations();
            }
            // Opened from inside the admin panel (not a deep-link), so Back
            // should simply close the form rather than navigate away.
            this.obligationFormFromRoute = false;
            this.showObligationForm = true;
        },
        async submitObligationForm() {
            if (this.isSubmittingObligation) return;
            this.isSubmittingObligation = true;
            try {
                const payload = {
                    ...this.formData,
                    pdf_id: Number(this.formData.pdf_id),
                    obligation_id: Number(this.formData.obligation_id),
                    no_of_day_delays: Number(this.formData.no_of_day_delays || 0),
                    settlement_amount: Number(this.formData.settlement_amount || 0),
                    other_obligation: this.formData.other_obligation || ""
                };
                const res = await axios.post(this.$API_URL + "/company_admin/performance-obligation-failure", payload, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                if (res.data) {
                    // The letter + mail draft are generated in the background, so the
                    // record is saved instantly and the file appears once the task
                    // finishes (the user gets an in-app notification).
                    notify.success(res.data.message || 'Claim saved. You’ll be notified when the letter is ready.');
                    this.showObligationForm = false;
                    this.fetchObligations();

                    // Came here from a project's Compensation Claim portlet →
                    // return to that project instead of stranding the user in the
                    // admin panel. Done before formData is cleared, since the
                    // fallback route needs the pdf_id.
                    const cameFromProject = this.obligationFormFromRoute;
                    if (cameFromProject) this.closeObligationForm();

                    this.formData = {
                        pdf_id: "", obligation_id: "", obligation: "", send_to: "", failure_description: "", letter_required: true, obligation_failure_date: "", no_of_day_delays: 0, settlement_amount: 0
                    };
                }
            } catch (error) {
                console.error(error);
                const detail = error.response?.data?.detail;
                notify.error(`Couldn’t save the claim: ${typeof detail === 'string' ? detail : error.message}. Check the details and try again.`);
            } finally {
                this.isSubmittingObligation = false;
            }
        },
        togglePdfExpand(pdfId) {
            // The expanded folders (contract / obligation documents) are post-bid.
            if (!POST_BID_ENABLED) return;
            this.expandedPdfId = this.expandedPdfId === pdfId ? null : pdfId;
        },
        toggleFolder(pdfId, folderName) {
            const key = `${pdfId}_${folderName}`;
            this.openFolders = { ...this.openFolders, [key]: !this.openFolders[key] };
            if (this.openFolders[key] && folderName === 'Contract Documents') {
                this.fetchContractFiles(pdfId);
            }
            if (this.openFolders[key] && folderName === 'Obligation Documents') {
                this.fetchObligationFiles(pdfId);
            }
        },
        async fetchContractFiles(pdfId) {
            if (this.contractFiles[pdfId]) return; // already loaded
            this.loadingContractFiles = { ...this.loadingContractFiles, [pdfId]: true };
            try {
                const res = await axios.get(
                    `${this.$API_URL}/company_admin/mail-records?project_id=${pdfId}&page=1&page_size=100`,
                    { headers: { Authorization: 'Bearer ' + this.getAccessToken() } }
                );
                const files = (res.data.items || [])
                    .filter(r => r.has_file)
                    .map(r => ({
                        id: r.id,
                        name: r.filepath ? r.filepath.replace(/\\/g, '/').split('/').pop() : `File_${r.id}.pdf`,
                        date: r.email_date,
                        type: r.email_type
                    }));
                this.contractFiles = { ...this.contractFiles, [pdfId]: files };
            } catch (e) {
                console.error(e);
                this.contractFiles = { ...this.contractFiles, [pdfId]: [] };
            } finally {
                this.loadingContractFiles = { ...this.loadingContractFiles, [pdfId]: false };
            }
        },
        isFolderOpen(pdfId, folderName) {
            return !!this.openFolders[`${pdfId}_${folderName}`];
        },
        fileIconColor(name) {
            const ext = name.split('.').pop().toLowerCase();
            if (ext === 'pdf') return '#dc2626';
            if (['doc', 'docx'].includes(ext)) return '#2563eb';
            if (['xls', 'xlsx'].includes(ext)) return '#16a34a';
            if (['jpg', 'jpeg', 'png'].includes(ext)) return '#9333ea';
            return '#64748b';
        },
        async fetchObligationFiles(pdfId) {
            if (this.obligationFiles[pdfId]) return;
            this.loadingObligationFiles = { ...this.loadingObligationFiles, [pdfId]: true };
            try {
                const res = await axios.get(
                    `${this.$API_URL}/company_admin/performance-obligations-failures?pdf_id=${pdfId}`,
                    { headers: { Authorization: 'Bearer ' + this.getAccessToken() } }
                );
                const files = (res.data || [])
                    .filter(r => r.pdf_letter_name)
                    .map(r => ({
                        id: r.id,
                        name: r.pdf_letter_name.replace(/\\/g, '/').split('/').pop(),
                        date: r.created_date,
                        obligation: r.obligation
                    }));
                this.obligationFiles = { ...this.obligationFiles, [pdfId]: files };
            } catch (e) {
                console.error(e);
                this.obligationFiles = { ...this.obligationFiles, [pdfId]: [] };
            } finally {
                this.loadingObligationFiles = { ...this.loadingObligationFiles, [pdfId]: false };
            }
        },
        getDummyFolders() {
            return [
                { name: 'Contract Documents', files: [] },
                { name: 'Obligation Documents', files: [] },
            ];
        },
        cleanPdfName(name) {
            if (!name) return 'Unknown';
            // Multiple files comma separated — pehla hi lo
            const first = name.split(',')[0].trim();
            // Extension hata do
            return first.replace(/\.pdf/gi, '').trim();
        },
        stripPdfExt(name) {
            if (!name) return '';
            // Keep all (comma-joined) names but drop every .pdf
            return name.replace(/\.pdf/gi, '');
        },
        formatDate(d) {
            if (!d) return 'N/A';
            return new Date(d).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        },
        copyKey(key, id) {
            navigator.clipboard.writeText(key);
            this.copiedId = id;
            setTimeout(() => { this.copiedId = null; }, 2000);
        },
        async fetchEmailRecords(page = 1) {
            try {
                this.emailRecordsPage = page;
                let url = `${this.$API_URL}/company_admin/mail-records?page=${page}&page_size=10`;
                
                if (this.emailFilters.project_id) {
                    url += `&project_id=${this.emailFilters.project_id}`;
                }
                if (this.emailFilters.email_type) {
                    url += `&email_type=${this.emailFilters.email_type}`;
                }
                if (this.emailFilters.start_date) {
                    url += `&start_date=${this.emailFilters.start_date}`;
                }
                if (this.emailFilters.end_date) {
                    url += `&end_date=${this.emailFilters.end_date}`;
                }
                if (this.emailFilters.content_search) {
                    url += `&content_search=${encodeURIComponent(this.emailFilters.content_search)}`;
                }
                
                const res = await axios.get(url, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.emailRecords = res.data.items || [];
                this.emailRecordsTotalPages = res.data.total_pages || 1;
            } catch (e) {
                console.error(e);
                this.emailRecords = [];
            }
        },
        async viewEmailDetail(emailId) {
            try {
                const res = await axios.get(`${this.$API_URL}/company_admin/mail-records/${emailId}`, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                this.emailDetail = res.data;
            } catch (e) {
                console.error(e);
                notify.error('Couldn’t load the email. Check your connection and try again.');
            }
        },
        async deleteEmailRecord(emailId) {
            const ok = await confirmAction({
                title: 'Delete Email Record?',
                message: 'The email and any attached file are removed. This can’t be undone.',
                confirmLabel: 'Delete Email Record',
                destructive: true,
            });
            if (!ok) return;
            try {
                await axios.delete(`${this.$API_URL}/company_admin/mail-records/${emailId}`, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() }
                });
                notify.success('Email record deleted');
                this.fetchEmailRecords(this.emailRecordsPage);
            } catch (e) {
                console.error(e);
                notify.error('Couldn’t delete the email record. Try again.');
            }
        },
        async downloadMailPdf(mailPdfId) {
            if (this.downloadingEmailIds.includes(mailPdfId)) return;
            this.downloadingEmailIds.push(mailPdfId);
            try {
                const res = await axios.get(`${this.$API_URL}/company_admin/download-mail/${mailPdfId}`, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() },
                    responseType: 'blob'
                });

                // Read actual MIME type from response (could be PDF or ZIP)
                const contentType = res.headers['content-type'] || res.headers['Content-Type'] || 'application/octet-stream';
                const isZip = contentType.includes('zip');

                // Determine filename
                let filename = isZip ? `mail_files_${mailPdfId}.zip` : `mail_pdf_${mailPdfId}.pdf`;
                const disp = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                if (disp) {
                    const m = disp.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)/i);
                    if (m && m[1]) filename = decodeURIComponent(m[1].replace(/["']/g, ''));
                }

                // Create blob with correct MIME type to prevent corruption
                const blob = new Blob([res.data], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                console.error(e);
                notify.error('Couldn’t download the file. Check your connection and try again.');
            } finally {
                this.downloadingEmailIds = this.downloadingEmailIds.filter(id => id !== mailPdfId);
            }
        },

        async downloadObligationPdf(obligationPdfId) {
            if (this.downloadingEmailIds.includes(obligationPdfId)) return;
            this.downloadingEmailIds.push(obligationPdfId);
            try {
                const res = await axios.get(`${this.$API_URL}/company_admin/download-obligation/${obligationPdfId}`, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() },
                    responseType: 'blob'
                });

                // Read actual MIME type from response (could be PDF or ZIP)
                const contentType = res.headers['content-type'] || res.headers['Content-Type'] || 'application/octet-stream';
                const isZip = contentType.includes('zip');

                // Determine filename
                let filename = isZip ? `obligation_files_${obligationPdfId}.zip` : `obligation_pdf_${obligationPdfId}.pdf`;
                const disp = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                if (disp) {
                    const m = disp.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)/i);
                    if (m && m[1]) filename = decodeURIComponent(m[1].replace(/["']/g, ''));
                }

                // Create blob with correct MIME type to prevent corruption
                const blob = new Blob([res.data], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                console.error(e);
                notify.error('Couldn’t download the file. Check your connection and try again.');
            } finally {
                this.downloadingEmailIds = this.downloadingEmailIds.filter(id => id !== obligationPdfId);
            }
        },

        async downloadCompanyPdf(pdfId) {
            if (this.downloadingPdfIds.includes(pdfId)) return;
            this.downloadingPdfIds.push(pdfId);
            try {
                const res = await axios.get(`${this.$API_URL}/company_admin/download-pdf/${pdfId}`, {
                    headers: { Authorization: 'Bearer ' + this.getAccessToken() },
                    responseType: 'blob'
                });

                // Read actual MIME type from response (could be PDF or ZIP for multi-file projects)
                const contentType = res.headers['content-type'] || res.headers['Content-Type'] || 'application/octet-stream';
                const isZip = contentType.includes('zip');

                // Determine correct filename with right extension
                let filename = isZip ? `project_files_${pdfId}.zip` : `project_pdf_${pdfId}.pdf`;
                const disp = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                if (disp) {
                    const m = disp.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)/i);
                    if (m && m[1]) filename = decodeURIComponent(m[1].replace(/["']/g, ''));
                }

                // Create blob with correct MIME type to prevent file corruption
                const blob = new Blob([res.data], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                console.error(e);
                notify.error('Couldn’t download the file. Check your connection and try again.');
            } finally {
                this.downloadingPdfIds = this.downloadingPdfIds.filter(id => id !== pdfId);
            }
        }
    }
}
</script>

<style scoped>
/* State-of-the-Art Bento-Glass System */

/* Background Decorative Layer */
.file-list-wrapper {
    position: relative;
    padding: 0 2rem 2rem 2rem;
    min-height: 100%;
    background: radial-gradient(circle at 0% 0%, rgba(79, 172, 254, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 100% 100%, rgba(0, 242, 254, 0.05) 0%, transparent 50%);
}

/* Centered Smart Hub Header */
.admin-header-premium {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    position: relative;
    z-index: 100;
}

/* ADVANCED FLOATING COMMAND DOCK (ADMIN) */
.tabs-modern-dock {
    display: inline-flex;
    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    padding: 8px;
    border-radius: 30px;
    gap: 8px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.1),
                inset 0 0 0 1px rgba(255, 255, 255, 0.3);
    position: relative;
    pointer-events: auto;
}

.tab-dock-btn {
    padding: 10px 22px;
    border: none;
    border-radius: 20px;
    background: transparent;
    color: #64748b;
    font-size: 0.82rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 2;
}

.tab-dock-btn svg {
    width: 18px;
    height: 18px;
    transition: all 0.4s ease;
    opacity: 0.6;
}

.tab-dock-btn:hover {
    color: #1e293b;
    background: rgba(255, 255, 255, 0.5);
}

.tab-dock-btn:hover svg {
    transform: scale(1.1);
    opacity: 1;
}

/* ACTIVE STATE WITH CONTEXTUAL COLORS */
.tab-dock-btn.active {
    background: #ffffff;
    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.05);
    transform: scale(1.02);
}

/* Admin Tabs Specific Colors */
.tab-dock-btn.active:nth-child(1) { color: #0369a1; } /* Overview */
.tab-dock-btn.active:nth-child(2) { color: #6d28d9; } /* Team */
.tab-dock-btn.active:nth-child(3) { color: #be123c; } /* Bids */
.tab-dock-btn.active:nth-child(4) { color: #047857; } /* Licenses */
.tab-dock-btn.active:nth-child(5) { color: #b45309; } /* Compensation Claims */

.tab-dock-btn.active svg {
    opacity: 1;
    filter: drop-shadow(0 0 3px currentColor);
}

.tab-dock-btn.active::after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 16px;
    height: 4px;
    border-radius: 10px;
    background: currentColor;
    box-shadow: 0 0 10px currentColor;
    animation: bounceIndicator 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes bounceIndicator {
    0% { transform: translateX(-50%) scaleX(0); opacity: 0; }
    100% { transform: translateX(-50%) scaleX(1); opacity: 1; }
}

@keyframes scaleFadeIn {
    from { transform: scale(0.9); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
}

/* Premium Action Button */
.btn-action-premium {
    background: #0071C5;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-weight: 700;
    font-size: 0.85rem;
    box-shadow: 0 4px 15px rgba(0, 113, 197, 0.3);
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    position: relative;
    overflow: hidden;
}

.btn-action-premium:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 113, 197, 0.4);
    filter: brightness(1.1);
}

.btn-action-premium:active {
    transform: translateY(1px);
}

/* Subtle Glow behind the dock */
.tabs-modern::after {
    content: '';
    position: absolute;
    inset: -15px;
    background: radial-gradient(circle at center, rgba(79, 172, 254, 0.1), transparent 70%);
    z-index: -1;
    pointer-events: none;
}

/* Bento Grid Stats */
.premium-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    margin-bottom: 3rem;
}

.premium-stat-card {
    background: white;
    padding: 2rem;
    border-radius: 32px;
    border: 1px solid rgba(226, 232, 240, 0.5);
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.02), 0 10px 30px -10px rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    height: 160px;
    justify-content: flex-start;
}

.user-info-stack {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    overflow: hidden;
}

.stack-name {
    font-weight: 700;
    color: #1e293b;
    font-size: 0.95rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stack-email {
    font-size: 0.75rem;
    color: #64748b;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.premium-stat-card:hover {
    transform: translateY(-8px) rotate(1deg);
    border-color: #0071C5;
    box-shadow: 0 30px 60px -12px rgba(0, 113, 197, 0.15);
}

.card-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

/* Stat Colors */
.blue .card-icon { background: #0ea5e9; }
.purple .card-icon { background: #8b5cf6; }
.cyan .card-icon { background: #06b6d4; }
.green .card-icon { background: #10b981; }

.card-header-compact {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    margin-bottom: 0.5rem;
}

.stat-number {
    font-size: 2.5rem !important;
    margin: 0 !important;
    color: #1e293b;
    font-weight: 700;
    letter-spacing: -0.05em;
    line-height: 1;
}

.card-info {
    margin-top: auto;
}

.card-info h4 {
    font-size: 0.7rem;
    color: #64748b;
    text-transform: uppercase;
    font-weight: 700;
    margin: 0;
}

/* Modern List System (Replacing Flat Tables) */
.list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    animation: staggerIn 0.6s ease-out;
}

.list-item-card {
    background: white;
    padding: 1.25rem 2rem;
    border-radius: 24px;
    border: 1px solid rgba(226, 232, 240, 0.8);
    display: grid;
    grid-template-columns: 2fr 2fr 1.5fr 1fr;
    align-items: center;
    transition: all 0.3s ease;
}

.list-item-card:hover {
    background: #f8fafc;
    transform: scale(1.01) translateX(10px);
    border-color: #0071C5;
}

/* Column heading row. Its horizontal padding matches the row cards
   (2rem padding + 1px border) so header and cells share the same column edges. */
.list-header-row {
    display: grid;
    align-items: center;
    padding: 1.25rem calc(2rem + 1px);
    border-bottom: 2px solid #f1f5f9;
    margin-bottom: 1.5rem;
}

.list-header-cell {
    font-size: 0.75rem;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
}

.list-header-cell.is-center { text-align: center; }
.list-header-cell.is-end { text-align: right; }

/* One grid template per tab, shared by the heading row and that tab's rows.
   Compensation Claims carry one extra column at the end for the letter download. */
.list-cols.cols-users { grid-template-columns: 2.2fr 1.8fr 1.5fr 1fr; }
.list-cols.cols-pdfs { grid-template-columns: 2.2fr 1.8fr 1.5fr 1fr 0.5fr; }
.list-cols.cols-licenses,
.list-cols.cols-emails { grid-template-columns: 2fr 2fr 1.5fr 1fr; }
.list-cols.cols-obligations { grid-template-columns: 2fr 2fr 1.5fr 1fr 130px; }

/* Letter download cell — pinned to the end of the row. */
.obligation-letter-cell {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

/* ID Badge */
.premium-id {
    font-weight: 700;
    color: #64748b;
    font-size: 0.8rem;
}

/* User Profiling */
.user-meta-stack {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.user-visual {
    width: 44px;
    height: 44px;
    background: #f1f5f9;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    color: #0071C5;
    font-size: 1.25rem;
    border: 2px solid white;
    box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

.user-name {
    font-weight: 700;
    color: #0f172a;
    display: block;
}

.user-email {
    font-size: 0.8rem;
    color: #64748b;
}

/* Data Pill */
.data-pill {
    background: #f8fafc;
    padding: 0.5rem 1rem;
    border-radius: 100px;
    font-weight: 600;
    font-size: 0.85rem;
    color: #334155;
    width: fit-content;
}

/* Status Blob */
.status-blob {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 1rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    width: fit-content;
}

.status-blob.active { background: #dcfce7; color: #166534; }
.status-blob.disabled { background: #fee2e2; color: #991b1b; }

.pulse-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
    animation: pulseGlow 1.5s infinite;
}

@keyframes pulseGlow {
    0% { transform: scale(0.8); opacity: 0.5; box-shadow: 0 0 0 0 rgba(22, 101, 52, 0.4); }
    70% { transform: scale(1.1); opacity: 1; box-shadow: 0 0 0 6px rgba(22, 101, 52, 0); }
    100% { transform: scale(0.8); opacity: 0.5; }
}

/* Key Display */
.key-container {
    background: #0f172a;
    padding: 0.6rem 1.25rem;
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    transition: transform 0.2s;
}

.key-container:active { transform: scale(0.95); }

.key-text {
    font-family: var(--font-mono);
    color: #4facfe;
    font-weight: 700;
    font-size: 0.9rem;
}

/* PDF Card variation */
.pdf-grid {
    grid-template-columns: 80px 3fr 2fr 1.5fr 1fr !important;
}

/* Compact Circular Stat in Card */
.mini-circular-progress {
    position: relative;
    width: 60px;
    height: 60px;
    margin-bottom: -0.5rem; /* Adjust to balance with icons */
}

.mini-circular-progress svg {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
}

.mini-circular-progress .circle-bg {
    fill: none;
    stroke: #f1f5f9;
    stroke-width: 12;
}

.mini-circular-progress .circle-fill {
    fill: none;
    stroke: #10b981;
    stroke-width: 12;
    stroke-linecap: round;
    transition: stroke-dashoffset 1s ease-in-out;
    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.3));
}

.mini-percent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.75rem;
    font-weight: 700;
    color: #1e293b;
    letter-spacing: -0.05em;
}

/* Copy Toast Styles */
.key-wrapper {
    position: relative;
    width: fit-content;
}

.copy-toast {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    background: #4facfe;
    color: white;
    padding: 0.4rem 0.8rem;
    border-radius: 8px;
    font-size: 0.7rem;
    font-weight: 700;
    box-shadow: 0 10px 20px rgba(79, 172, 254, 0.3);
}

.copy-toast::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #4facfe;
}

/* Animations */
.pop-enter-active { animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
.pop-leave-active { animation: popIn 0.3s reverse ease-in; }

@keyframes popIn {
    0% { opacity: 0; transform: translateX(-50%) translateY(10px) scale(0.8); }
    100% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

/* Stagger Animation */
@keyframes staggerIn {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Empty State */
.box-empty {
    padding: 4rem;
    text-align: center;
    background: white;
    border-radius: 32px;
    border: 2px dashed #e2e8f0;
}

.empty-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    display: block;
}

/* Custom Scrollbar for dashboard-card-scrollable */
:deep(.dashboard-card-scrollable) {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

:deep(.dashboard-card-scrollable::-webkit-scrollbar) {
    width: 6px;
}

:deep(.dashboard-card-scrollable::-webkit-scrollbar-thumb) {
    background: #cbd5e1;
    border-radius: 10px;
}
/* Premium Form Design (Restored) */
.premium-form-card {
    background: #ffffff;
    border-radius: 28px;
    padding: 2.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05);
    margin-bottom: 2rem;
    position: relative;
    overflow: hidden;
    text-align: left;
}

.premium-form-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, #4f46e5, #3b82f6);
}

.form-header {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 2.5rem;
    justify-content: flex-start;
}

.header-icon {
    width: 60px;
    height: 60px;
    background: #f1f5f9;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4f46e5;
}

.header-icon svg {
    width: 28px;
    height: 28px;
}

.header-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.header-text h3 {
    margin: 0;
    font-size: var(--fs-h2);            /* 24px section title */
    line-height: var(--lh-h2);          /* 32px */
    font-weight: var(--fw-h2);          /* 600 */
    color: var(--text-primary);
    letter-spacing: -0.02em;
    text-align: left;
}

.header-text p {
    margin: 0.25rem 0 0 0;
    color: #64748b;
    font-size: 0.95rem;
    text-align: left;
}

.form-section {
    margin-bottom: 2rem;
    padding-bottom: 1rem;
}

.section-title {
    font-size: var(--fs-caption);       /* 12px eyebrow label */
    font-weight: var(--fw-semibold);    /* 600 */
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: var(--tracking-th); /* 0.08em */
    margin-bottom: 1.5rem;
    text-align: left;
}

.form-col-stack {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.input-group {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.input-group label {
    font-size: 0.85rem;
    font-weight: 700;
    color: #334155;
    margin-left: 2px;
    text-align: left;
}

.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.field-icon {
    position: absolute;
    left: 1rem;
    width: 18px;
    height: 18px;
    color: #64748b;
    pointer-events: none;
    transition: color 0.3s;
}

.pro-form input,
.pro-form select,
.pro-form textarea {
    width: 100%;
    padding: 0.85rem 1rem 0.85rem 3rem;
    background: #f8fafc;
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    font-family: inherit;
    font-size: 0.95rem;
    color: #0f172a;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;
    box-sizing: border-box;
    box-shadow: none;
    text-align: left;
}

.pro-form select.disabled-select {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #e2e8f0;
}

.input-wrapper.text-area textarea {
    padding-left: 1.25rem;
    resize: vertical;
}

.input-wrapper.prefix input {
    padding-left: 2.5rem;
}

.input-prefix {
    position: absolute;
    left: 1rem;
    font-weight: 700;
    color: #64748b;
    font-size: 1rem;
}

.input-wrapper.suffix input {
    padding-right: 4rem;
}

.input-suffix {
    position: absolute;
    right: 1.25rem;
    font-size: 0.85rem;
    font-weight: 700;
    color: #64748b;
}

.pro-form input:focus,
.pro-form select:focus,
.pro-form textarea:focus {
    background: #ffffff;
    border-color: #3b82f6;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.input-wrapper input:focus + .field-icon,
.input-wrapper select:focus + .field-icon {
    color: #3b82f6;
}

.form-footer-actions {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    background: #f8fafc;
    padding: 1.5rem;
    border-radius: 20px;
    border: 1px solid #e2e8f0;
}

.custom-checkbox-premium {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
}

.custom-checkbox-premium input {
    display: none;
}

.checkmark-box {
    width: 20px;
    height: 20px;
    background: white;
    border: 2px solid #94a3b8;
    border-radius: 4px;
    position: relative;
    transition: all 0.2s;
}

.custom-checkbox-premium input:checked + .checkmark-box {
    background: #0f172a;
    border-color: #0f172a;
}

.checkmark-box::after {
    content: '';
    position: absolute;
    left: 6px;
    top: 2px;
    width: 4px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    opacity: 0;
    transition: opacity 0.2s;
}

.custom-checkbox-premium input:checked + .checkmark-box::after {
    opacity: 1;
}

.check-title {
    display: block;
    font-weight: 700;
    color: #1e293b;
    font-size: 0.9rem;
    text-align: left;
}

.check-sub {
    font-size: 0.75rem;
    color: #64748b;
    font-weight: 500;
    text-align: left;
}

.btn-submit-pro {
    background: #0f172a; /* Solid enterprise slate  */
    color: white;
    padding: 1rem 2rem;
    border: none;
    border-radius: 8px; /* Sharp corners */
    font-weight: 700;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.btn-submit-pro:hover {
    background: #1e293b;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-submit-pro svg {
    transition: transform 0.3s;
}

.btn-submit-pro:hover svg {
    transform: translate(3px, -3px);
}

.btn-cancel-floating {
    margin-bottom: 2rem;
    padding: 0.65rem 1rem;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    color: #475569;
    font-weight: 600;
    font-size: 0.85rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-cancel-floating:hover {
    background: #f1f5f9;
    color: #0f172a;
    border-color: #94a3b8;
}

.full-page-form {
    min-height: 600px;
}

/* "Back to Bid" bar shown when the panel is opened from a bid */
.back-to-bid-bar {
    padding: 0 0 0.5rem;
}

.back-to-bid-bar .btn-cancel-floating {
    margin-bottom: 1rem;
}

.btn-cancel-floating:focus-visible,
.btn-action-premium:focus-visible,
.btn-reprocess:focus-visible,
.btn-action-small:focus-visible,
.tab-dock-btn:focus-visible,
.premium-stat-card.clickable:focus-visible {
    outline: 2px solid #0071C5;
    outline-offset: 2px;
}

/* Email detail sheet */
.email-detail-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.55);
    display: grid;
    place-items: center;
    padding: 20px;
    z-index: 1000;
}

.email-detail-sheet {
    background: #ffffff;
    border-radius: 16px;
    width: 100%;
    max-width: 640px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

.email-detail-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.1rem 1.5rem;
    border-bottom: 1px solid #e2e8f0;
}

.email-detail-head h3 {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 700;
    color: #0f172a;
}

.email-detail-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    line-height: 1;
    color: #64748b;
    cursor: pointer;
    border-radius: 6px;
}

.email-detail-meta {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.35rem 1rem;
    margin: 0;
    padding: 1rem 1.5rem 0;
    font-size: 0.85rem;
}

.email-detail-meta dt {
    color: #64748b;
    font-weight: 600;
}

.email-detail-meta dd {
    margin: 0;
    color: #0f172a;
}

.email-detail-body {
    margin: 1rem 1.5rem;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 10px;
    font-size: 0.88rem;
    color: #334155;
    line-height: 1.55;
    white-space: pre-wrap;
    overflow-y: auto;
}

.email-detail-foot {
    display: flex;
    justify-content: flex-end;
    padding: 0 1.5rem 1.25rem;
}

.email-detail-foot .btn-cancel-floating {
    margin-bottom: 0;
}

/* Email Records Styles */
.action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}

.btn-action-small {
    padding: 0.5rem;
    border: 1px solid #e2e8f0;
    background: white;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-action-small:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.btn-action-small.danger:hover {
    background: #fee2e2;
    border-color: #fca5a5;
}

.btn-action-small svg {
    width: 14px;
    height: 14px;
    color: #64748b;
}

.btn-action-small.danger svg {
    color: #dc2626;
}

.spinner-animate {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* ── Contract Docs Folder Explorer ── */
.contract-doc-card {
    background: white;
    border-radius: 20px;
    border: 1px solid rgba(226, 232, 240, 0.8);
    overflow: hidden;
    transition: border-color 0.2s;
}
.contract-doc-card:hover {
    border-color: #93c5fd;
}
.contract-doc-row {
    display: grid;
    align-items: center;
    padding: 1.1rem 2rem;
    cursor: pointer;
    transition: background 0.2s;
}
.contract-doc-row:hover {
    background: #f8fafc;
}
.folder-tree-wrapper {
    border-top: 1px solid #f1f5f9;
    padding: 1rem 1.5rem 1.2rem 1.5rem;
    background: #fafbfc;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.folder-block {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #f1f5f9;
}
.folder-header {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.6rem 1rem;
    background: #fff;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s;
}
.folder-header:hover {
    background: #fef9ec;
}
.folder-name {
    font-size: 0.85rem;
    font-weight: 700;
    color: #374151;
}
.folder-count {
    font-size: 0.7rem;
    color: #64748b;
    background: #f1f5f9;
    padding: 0.15rem 0.5rem;
    border-radius: 20px;
    font-weight: 600;
}
.file-list {
    display: flex;
    flex-direction: column;
    border-top: 1px solid #f1f5f9;
}
.file-row {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.5rem 1rem 0.5rem 2rem;
    border-bottom: 1px solid #f8fafc;
    transition: background 0.15s;
}
.file-row:last-child {
    border-bottom: none;
}
.file-row:hover {
    background: #f8fafc;
}
.file-name {
    font-size: 0.82rem;
    color: #374151;
    font-weight: 500;
}
.file-size {
    font-size: 0.72rem;
    color: #64748b;
    font-weight: 500;
    min-width: 55px;
    text-align: right;
}
.file-download-btn {
    background: none;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 0.25rem 0.4rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #64748b;
    transition: all 0.15s;
}
.file-download-btn:hover {
    background: #eff6ff;
    border-color: #93c5fd;
    color: #2563eb;
}
.expand-enter-active,
.expand-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}
.expand-enter-from,
.expand-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}

/* ===== AI Reprocessing tab ===== */
.reprocess-intro {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem 1.5rem;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 16px;
    color: #1d4ed8;
    margin-bottom: 1.5rem;
}
.reprocess-intro h4 { margin: 0; font-size: 0.95rem; font-weight: 700; color: #1e3a8a; }
.reprocess-intro p { margin: 0.15rem 0 0 0; font-size: 0.8rem; color: #475569; }

.reprocess-picker { margin-bottom: 1.5rem; }
.reprocess-picker label {
    display: block;
    font-size: 0.75rem;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
}
.reprocess-picker select {
    width: 100%;
    max-width: 480px;
    padding: 0.65rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.9rem;
    background: white;
}

.reprocess-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 1rem;
}
.reprocess-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 1.1rem 1.25rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}
.reprocess-card:hover { border-color: #93c5fd; box-shadow: 0 6px 16px rgba(59, 130, 246, 0.08); }
.reprocess-card-text { display: flex; flex-direction: column; gap: 0.25rem; }
.reprocess-name { font-weight: 700; color: #0f172a; font-size: 0.9rem; }
.reprocess-desc { font-size: 0.78rem; color: #64748b; line-height: 1.35; }

.btn-reprocess {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    flex-shrink: 0;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 10px;
    background: #0071C5;
    color: white;
    font-weight: 700;
    font-size: 0.8rem;
    cursor: pointer;
    transition: background 0.2s;
}
.btn-reprocess:hover:not(:disabled) { background: #005a9e; }
.btn-reprocess:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
